import * as React from 'react';
import Box from '@mui/material/Box';
import {ResponsiveChartContainer} from '@mui/x-charts/ResponsiveChartContainer';
import {BarPlot} from '@mui/x-charts/BarChart';
import {LinePlot, MarkPlot} from '@mui/x-charts/LineChart';
import {ChartsXAxis} from '@mui/x-charts/ChartsXAxis';
import {ChartsLegend} from '@mui/x-charts/ChartsLegend';
import {ChartsYAxis} from '@mui/x-charts/ChartsYAxis';

export default function BasicComposition(props: any) {

  
  
  return (

    <Box sx={{ width: '100%', height: 300 }}>
      {/* @ts-ignore */}
      <ResponsiveChartContainer
      margin={{ left: 45, right:10 }}
       colors={[
        '#ffa13d',
        '#ff4545',
        '#ffd600',
        '#ca74ff',
        '#0093ff',
      ]}  
        series={props.monthSeries}
        
        xAxis={[
          {
            data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12','13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24','25','26','27','28','29','30','31'],
            scaleType: 'band',
            id: 'x-axis-id',
          },
        ]}
      >
        <BarPlot />
        <LinePlot />
        <ChartsXAxis label="" position="bottom" axisId="x-axis-id" />
        <ChartsYAxis />
        <ChartsLegend 
          slotProps={{
            legend: {
              direction: 'row',
              position: { vertical: 'bottom', horizontal: 'middle' },
              padding: -5,
              labelStyle: {
                fontSize: 12,
              },
              itemMarkWidth: 10,
              itemMarkHeight: 10,
            },
          }}
        />

      </ResponsiveChartContainer >
    </Box>

  );
}